<template>
 <ul class="px-[10px]">
    <TokenCard
      v-for="value in filteredTransactions(tokens).items"
      :key="value.id"
      :token="value" />
    <div v-if="filteredTransactions(tokens).meta.count > maxResults" class="flex justify-end mt-[5px]">
      <a
        @click="loadMoreResults"
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </a>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import TokenCard from '@/components/common/TokenCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'TokensList',
  components: {
    TokenCard,
  },
  props: {
    tokens: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    loadMoreResults() {
      // Navigate to AllResults page with tokens type
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.token },
        query: this.$route.query
      });
    }
  }
}
</script>
